import { useEffect, useState } from 'react';

export const getBreakpointValue = (breakpoint: BreakpointKey) => {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(`--breakpoint-${breakpoint}`)
    .trim();

  return value;
};

export const createQueryBreakpoint = (
  breakpoint: BreakpointKey,
  type: 'min' | 'max'
) => {
  const breakpointValue = getBreakpointValue(breakpoint);
  if (type === 'max') {
    const value = Number(breakpointValue.replace('px', '')) - 1;
    const maxBreakpointValue = value + 'px';
    return window.matchMedia(`(max-width: ${maxBreakpointValue})`);
  }
  return window.matchMedia(`(min-width: ${breakpointValue})`);
};

type BreakpointKey = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const useMediaQuery = (
  breakpoint: BreakpointKey,
  type: 'min' | 'max' = 'min'
) => {
  const [isMatch, setIsMatch] = useState(false);

  useEffect(() => {
    const updateMatch = () => {
      const mediaQuery = createQueryBreakpoint(breakpoint, type);
      setIsMatch(mediaQuery.matches);
    };

    const mediaQuery = createQueryBreakpoint(breakpoint, type);

    setIsMatch(mediaQuery.matches);

    const handler = () => updateMatch();

    mediaQuery.addEventListener('change', handler);

    return () => {
      mediaQuery.removeEventListener('change', handler);
    };
  }, [breakpoint]);

  return isMatch;
};
